// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__O3TdG","content":"LoadingAlert_content__3Kqo2"};